import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-insert-options-menu',
  standalone: true,
  imports: [TranslateModule, MatButtonModule, MatIconModule],
  template: `
    <div class="custom-context-menu-wrapper d-flex flex-column gap-2 p-2">
      <button class="justify-content-start" mat-flat-button (click)="selectOption('chunks')">
        <mat-icon>notes</mat-icon>
        <span>{{ 'ContentRefiner.InsertAsChunks' | translate }}</span>
      </button>
      <button class="justify-content-start" mat-flat-button (click)="selectOption('canvas')">
        <mat-icon>wysiwyg</mat-icon>
        <span>{{ 'ContentRefiner.InsertAsCanvas' | translate }}</span>
      </button>
      <button class="justify-content-start" mat-flat-button (click)="selectOption('markdown')">
        <mat-icon>markdown</mat-icon>
        <span>{{ 'ContentRefiner.InsertAsMarkdown' | translate }}</span>
      </button>
    </div>
  `,
  styles: [
    `
      .justify-content-start {
        justify-content: flex-start !important;
        display: flex !important;
        align-items: center;
        gap: 8px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsertOptionsMenuComponent {
  @Output() optionSelected = new EventEmitter<'chunks' | 'canvas' | 'markdown'>();

  selectOption(option: 'chunks' | 'canvas' | 'markdown'): void {
    this.optionSelected.emit(option);
  }
}
